import React, { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TimelineMax as Timeline } from 'gsap';
import interact from 'interactjs';

import MapIcon from '../icons/map.svg'
import DragIcon from '../icons/down.svg';

import { showMapPanel, useIsMobile, useMapPanel } from '../slices/ui'

export class SlidePanel extends React.PureComponent {

  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.drag = React.createRef();
    this.dragStartHandler = this.dragStartHandler.bind(this);
    this.dragMoveHandler = this.dragMoveHandler.bind(this);
    this.dragEndHandler = this.dragEndHandler.bind(this);
    this.toggleHandler = this.toggleHandler.bind(this);
    this.openedCallback = this.openedCallback.bind(this);
    this._dragMove = null;
    this._currentSize = null;
    this._currentProsgress = null;
  }

  componentDidMount(){
    this.updateInteract();
    this.updateTimeLine();
    this.updateStatus();
  }

  componentWillUnmount(){
    if (this.timeline){
      this.timeline.seek(0);
      this.timeline.clear();
      this.timeline = null;
      this.container.current.style = '';
    }
    if (this.interact){
      this.interact.unset();
      this.interact = null;
    }
    this._dragMove = null;
    this._currentSize = null;
    this._currentProsgress = null;
  }

  componentDidUpdate(prevProps, prevState){
    if (this.props.status != prevProps.status){
      requestAnimationFrame(()=>{
        this.updateStatus();
      });
    }
    return true;
  }

  render() {
    return (
      <div ref={this.container} 
        aria-hidden={(this.props.status != 'close') ? "false":"true"} 
        className={this.props.className} 
        role={"dialog"}>
        <button ref={this.drag} 
                className="toggle button basic"
                onClick={this.toggleHandler}>
            <DragIcon/>
        </button> 
        {this.props.children}
      </div>
    )
  }

  dragStartHandler(event){
    this._dragMove = 0;
    this._currentSize = this.container.current.offsetHeight;
    this._currentProsgress = this.timeline.progress()
  }

  dragMoveHandler(event){
    this._dragMove = this._dragMove + event.dy;
    const progress = this._currentProsgress - (this._dragMove / this._currentSize)
    this.timeline.pause();
    this.timeline.progress(progress);
  }

  dragEndHandler(event){
    if (Math.abs(this._currentProsgress - this.timeline.progress()) < 0.2){
      this.timeline.play();
    } else {
      this.toggleHandler();
    }
  }

  toggleHandler(){
    this.props.toggleHandler(); 
  }

  closeHandler(){
    this.props.closeHandler();
  }

  openedCallback(){
    window.requestAnimationFrame(()=>{
      const ele = this.container.current?.querySelector('button');
      if (ele){
        ele.focus();
      }
    });
  }

  updateTimeLine(){
    if (this.timeline){
      this.timeline.clear();
    }
    this.timeline = new Timeline({ paused: true });
    this.timeline.addLabel("close")
    this.timeline.set(
      "#content",
      {visibility:'hidden'}, 
      0.3
    )
    this.timeline.set(
      "#content",
      {visibility:'visible'}, 
      0.299
    )
    this.timeline.fromTo(
      this.container.current, 
      {y:'100%', visibility:'hidden'},
      {y:'0%', visibility:'visible', duration: 0.3, ease:'none'},
      "0"
    );
    
    this.timeline.addLabel("open", ">")
    this.timeline.eventCallback('onComplete', this.openedCallback)
    this.timeline.progress( this.props.status === 'open' ? 1 : 0)
  }

  updateInteract(){
    if (this.interact){
      this.interact.unset();
    }
    this.interact = interact(this.drag.current).draggable({
      onstart: this.dragStartHandler,
      onmove: this.dragMoveHandler, 
      onend: this.dragEndHandler,
      startAxis: 'y',
      lockAxis: 'y',
    }).styleCursor(false);
  }

  updateStatus(){
    const status = this.props.status;
    this.timeline.tweenTo(status)
  }

}


const MobileView = (props) => {
  const dispatch = useDispatch()
  const isOpen = useMapPanel()
  const isRendered = useRef(isOpen)
  const toggeleHandler = () => {
    dispatch(showMapPanel(!isOpen))
  }
  const closeHandler = () => {
    dispatch(showMapPanel(false))
  }
  const openHandler = () => {
    dispatch(showMapPanel(true))
  }

  if (isOpen) {
    isRendered.current = true
  }

  return (
    <>
      <button
        className="pwa__mappanel__showmap button secondary circular fa"
        aria-hidden={(isOpen) ? 'true' : 'false'}
        onClick={ openHandler }>
        <MapIcon/>
      </button>
      <SlidePanel status={(isOpen) ? 'open' : 'close'}
        closeHandler={ closeHandler }
        toggleHandler={ toggeleHandler }
        role={'dialog'}
        className={'pwa__mappanel mobile'}>
        { isRendered.current && props.children }
      </SlidePanel>
    </>
  )
}

const MapPanel = (props) =>{
  const isMobile = useIsMobile()
  if (isMobile){
    return (
      <MobileView>
        { props.children }
      </MobileView>
    )
  } else {
    return (
      <section className={'pwa__mappanel desktop'}>
        { props.children }
      </section>
    )
  }
}
export default MapPanel;
